/**
 *
 * @returns {{app: string, socketApi: string, restApi: string, env: string}}
 */
export function getApiUrl() {
    const env = window.location.pathname.replace(/^\/([^\/]*)\/([^\/]*).*$/, '$1');
    const app = window.location.pathname.replace(/^\/([^\/]*)\/([^\/]*).*$/, '$2');
    let socketApi;
    let restApi;
    if (process.env.NODE_ENV === 'development') {
        socketApi = `${process.env.REACT_APP_REMOTE_HOST}${env}/api/${app}/notification/connect`;
        restApi = `${process.env.REACT_APP_REMOTE_HOST}${env}/api/${app}/`;
    }

    if (process.env.NODE_ENV === 'production') {
        socketApi = `/${env}/api/${app}/notification/connect`;
        restApi = `/${env}/api/${app}/`;
    }

    return {
        socketApi,
        restApi,
        env,
        app
    }
}